<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCheckmark_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.721 3.312a.999.999 0 0 0-1.414 0l-7.235 7.234-3.274-3.275a.999.999 0 1 0-1.414 1.414l3.981 3.981c.44.44 1.075.339 1.414 0l7.942-7.94a.998.998 0 0 0 0-1.414Z"
    />
</svg>
